<template>
  <div class="col-card position-relative" :data-submission="submission.id">

    <div class="d-flex justify-content-between">
      <h3 class="text-white text-uppercase mr-3">{{status(submission.status)}}</h3>
      <div class="ml-2 evolution-date"> {{date(submission.submitted)}}</div>
    </div>
    <div class="pos-rel mt-15 mb-3">
      <generic-chart
        v-if="subScores.length && subScoreLabels.length"
        style="height:200px"
        :type="'polarArea'"
        :legend="false"
        :ticks="false"
        :name="'submission-'+submission.id"
        :chart-data="[subScores]"
        :chart-labels="subScoreLabels">
      </generic-chart>

      <div class="evolution-score">{{truncate(submission.vipscore,1)}}</div>
    </div>
    <div v-if="submission.status === 'draft'" class="text-center">
      <button class="btn btn-primary btn-white">{{ $t('message.continue') }}</button>
    </div>
    <div v-else class="text-center">
      <div>
        <span>{{ $t('message.finalized') }}:</span><span> {{date(submission.submitted)}}</span>
      </div>
      <div class="mb-3">
        <span>{{ $t('message.reviewed') }}:</span>
        <span v-if="submission.reviewed" class="text-green">{{date(submission.reviewed)}}</span>
        <span v-else class="text-red">{{ $t('message.no') }}</span>
      </div>
      <button v-if="submission.reviewed" class="btn btn-primary btn-white">{{ $t('message.view') }}</button>
      <button v-else-if="userRole !== 'manager'" class="btn btn-primary btn-white">{{ $t('message.review') }}</button>
    </div>
    <div v-if="submission.status !== 'draft' && userRole !== 'manager'" class="text-center position-absolute submission-visibility toggler">
<!--      todo turn this code on again to enable submission unpublishing-->
      <button class="h-auto btn btn-link p-0"
              v-if="!loading"
              @click.prevent.stop="toggleSubmissionStatus">
        <small v-show="submission.published">
          <i class="fa-1x fal fa-fw fa-eye"></i>
        </small>
        <small v-show="!submission.published">
          <i class="fa-1x score-c-1 fal fa-fw fa-eye-slash"></i>
        </small>
      </button>
      <button class="h-auto btn btn-link p-0 disabled"
              v-if="loading"
              @click.prevent.stop="false">
        <small v-if="loading">
          <i class="fa-1x score-c-3 fa-fw fas fa-circle-notch fa-spin"></i>
        </small>
      </button>
<!--{{submission.published}}-->
    </div>
  </div>
</template>

<script>
  import store from "../../store/store";
  import GenericChart from "../Charts/GenericChart";

  export default {
    components: {
      GenericChart
    },
    data() {
      return {
        loading: false,
        subScores: [],
        subScoreLabels: [],
      }
    },
    watch: {
      submission() {
        this.getSubscores()
      },
      vitamins() {
        this.getSubscores()
      }
    },
    mounted() {
      this.getSubscores();
    },
    methods: {
      toggleSubmissionStatus() {
        let status = this.submission.published ? true : false;
        status = !status;
        this.loading = true;
        this.axios.put('/submissions/' + this.submission.id, {
          published: status ? 1 : 0
        }).then(r => {
          this.loading = false
          // console.log('saved sub published status', r);
          this.submission.published = r.data.published;
        })
      },
      getSubscores() {
        this.subScores = [];
        this.subScoreLabels = [];
        if (this.vitamins) {
          this.vitamins.forEach(vitamin => {
            this.subScores.push(this.vitaminScore(vitamin));
            this.subScoreLabels.push(this.localizedField(vitamin,'Title'));
            // console.log('titlte', vitamin.Title)
          })
        }
      },
      vitaminScore(vitamin, type = 'average') {
        let score = 0;
        const vitaminScores = this.submission.data.children;
        for (let key in vitaminScores) {
          if (vitaminScores[key].id === vitamin.id) {
            score = vitaminScores[key][type]
          }
        }
        return this.truncate(score, 2);
      },
      status(status) {
        let returnstatus;
        switch (status) {
          case 'draft':
            returnstatus = this.$t('message.draft');
            break;
          case 'final':
            returnstatus = this.$t('message.finalized');
            break;
          case 'reviewed':
            returnstatus = this.$t('message.reviewed');
            break;
        }
        return returnstatus
      },
      date(string) {
        const date = new Date(string);
        return date.toLocaleDateString('en-GB')
      },
    },
    props: {
      submission: {
        type: Object
      },
      vitamins: {
        type: Array
      }
    }
  }
</script>

<style>
.submission-visibility.toggler{
  right: 10px;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Evolution/Card.vue